export default __webpack_public_path__ + "static/media/fotoc-logo-new.dafd3949.png";